export const initialState = {
  isAuth: false,
  name: '',
  balance: 0,
  currency: '',
  role: null,
  id: null,
  isProcess: false,
};